export enum RuleEditorTabsEnum {
  RULE_STRUCTURE = 'rule_structure',
  TABLE = 'table',
}
